import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/LoginBanner.png'


const _withScopeId = n => (_pushScopeId("data-v-5d1587cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app__title ma-0" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "login-banner",
  src: _imports_0,
  alt: "EventMaster"
}, null, -1))
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "material-icons",
  style: {"width":"30px"}
}, "upload2", -1))
const _hoisted_5 = { class: "profile-image__label" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required" }, "* ", -1))
const _hoisted_7 = { class: "buttton__disabled__text" }

import { ref, computed, reactive } from "vue";
import { i18n } from "@/i18n";
import { showMessage } from "@/services/MessageService";
import { toBase64 } from "@/services/FileToBase64";
import { loaderStart, loaderDone } from "@/services/Loader";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { requiredElement } from "@/services/ValidatorService";

export default /*#__PURE__*/_defineComponent({
  __name: 'CompleteRegisterCard',
  setup(__props) {

const drawer = ref(true);
const store = useStore();
const route = useRoute();
const userData = computed(() => {
  return store.getters["user/data"];
});
const rulesRequired = ref(requiredElement);
const participant = reactive({
  firstName: "",
  lastName: "",
  secondLastName: "",
  profileImage: "",
  uid: userData.value ? userData.value.uid : "",
  email: userData.value ? userData.value.email : "",
  gender: "",
  birthday: "",
});
const genders = [
  {
    value: "male",
    label: i18n.global.t("register.gender.male"),
  },
  {
    value: "female",
    label: i18n.global.t("register.gender.female"),
  },
  {
    value: "other",
    label: i18n.global.t("register.gender.other"),
  },
];

const validForm = computed(() => {
  if (
    participant.firstName.length &&
    participant.secondLastName.length &&
    participant.lastName.length
  ) {
    return true;
  }
  return false;
});

function compressImg(fileImg, averageReduce) {
  return new Promise((resolve) => {
    const canvas = document.createElement("canvas");
    const img = new Image();
    img.src = fileImg;
    img.onload = () => {
      const width = img.width;
      const height = img.height;
      const average = averageReduce / 100;
      const newWidth = width * average;
      const newHeight = height * average;
      canvas.width = newWidth;
      canvas.height = newHeight;
      canvas.getContext("2d")?.drawImage(img, 0, 0, newWidth, newHeight);
      const dataURL = canvas.toDataURL("image/jpeg", average);
      resolve(dataURL);
    };
  });
}
async function setProfileImage(file) {
  if (file) {
    if (file.size < 5000_000) {
      const imageDataURL: any = await toBase64(file);
      const imageCompress: any = await compressImg(imageDataURL, 30);
      participant.profileImage = imageCompress;
    } else {
      showMessage({
        title: i18n.global.t("register.profileImageSizeError.title"),
        message: i18n.global.t("register.profileImageSizeError.message"),
        type: "error",
      });
    }
  }
}

async function registerParticipant() {
  loaderStart();
  const userData: any = {
    ...participant,
    fullName: `${participant.firstName} ${participant.lastName} ${participant.secondLastName}`,
    registerDate: new Date(),
  };
  await store.dispatch("event/registerParticipant", userData);
  userData.eventID = route.params.eventID as string;
  await store.dispatch("event/saveCardEventParticipantData", userData);
  loaderDone();
}

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: drawer.value,
    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((drawer).value = $event)),
    "custom-class": "complete-register-card",
    width: "400px",
    "show-close": false,
    "close-on-press-escape": false,
    "close-on-click-modal": false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 24,
            class: "text--center"
          }, {
            default: _withCtx(() => [
              _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t("register.accountComplete")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { class: "text-center" }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                class: "form__container",
                ref: "registerForm",
                model: participant
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { id: "image-contianer" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        (participant.profileImage.length > 0)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              id: "profile-image",
                              src: participant.profileImage,
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$refs.profileImage.click())),
                              alt: "profile"
                            }, null, 8, _hoisted_3))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              id: "profile-image",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$refs.profileImage.click()))
                            })),
                        _createElementVNode("div", {
                          class: "d-flex align-center",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$refs.profileImage.click()))
                        }, [
                          _hoisted_4,
                          _createElementVNode("div", _hoisted_5, _toDisplayString(!participant.profileImage.length
                      ? _ctx.$t("register.browseImage")
                      : _ctx.$t("register.changeImage")), 1)
                        ])
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        ref: "profileImage",
                        type: "file",
                        accept: "image/jpeg,image/png",
                        onChange: _cache[3] || (_cache[3] = ($event: any) => (setProfileImage(_ctx.$refs.profileImage.files[0])))
                      }, null, 544), [
                        [_vShow, false]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    prop: "firstName",
                    label: _ctx.$t('register.firstName'),
                    rules: rulesRequired.value
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: participant.firstName,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((participant.firstName) = $event)),
                        text: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label", "rules"]),
                  _createVNode(_component_el_form_item, {
                    prop: "lastName",
                    label: _ctx.$t('register.lastName'),
                    rules: rulesRequired.value
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: participant.lastName,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((participant.lastName) = $event)),
                        text: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label", "rules"]),
                  _createVNode(_component_el_form_item, {
                    prop: "secondLastName",
                    label: _ctx.$t('register.secondLastName'),
                    rules: rulesRequired.value
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: participant.secondLastName,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((participant.secondLastName) = $event)),
                        text: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label", "rules"]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('register.genderTitle')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: participant.gender,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((participant.gender) = $event)),
                        class: "m-2 w-full",
                        size: "large"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(genders, (gender) => {
                            return _createVNode(_component_el_option, {
                              key: gender.value,
                              label: gender.label,
                              value: gender.value
                            }, null, 8, ["label", "value"])
                          }), 64))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('register.birthday')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        class: "w-full",
                        "value-format": "YYYY-MM-DD",
                        modelValue: participant.birthday,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((participant.birthday) = $event)),
                        type: "date"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_row, {
                    type: "flex",
                    justify: "center",
                    align: "middle"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        span: 14,
                        class: "text--center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            style: {"margin-bottom":"10px"},
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (registerParticipant())),
                            class: "secondary__color__button",
                            disabled: !validForm.value
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("register.submit")), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      }),
                      (!validForm.value)
                        ? (_openBlock(), _createBlock(_component_el_col, {
                            key: 0,
                            span: 24,
                            class: "text--center text-pd"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, [
                                _hoisted_6,
                                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("register.disabledForm")), 1)
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})